import {ContentContainer, PageContainer, SponsorshipCard, SponsorshipContainer, SponsorshipImg, SponsorshipName, TitleBarContainer, TitleName } from "./styles";
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import oab from "../../assets/sponsors/oab.png";
import caama from "../../assets/sponsors/CAAMA.png";
import MendesELobato from "../../assets/sponsors/MendesELobato-1.png"
import OliviaCastro from "../../assets/sponsors/Olivia.png"
import Magnolia from "../../assets/sponsors/professoraMagnolia.png"
import kaioSaraiva from "../../assets/sponsors/kaioSaraiva.png"
import arenaAririzal from "../../assets/sponsors/arenaAririzal.png"
import arenaP12 from "../../assets/sponsors/arenap12.png"
import gilsonRamalho from "../../assets/sponsors/gilsonRamalho.png"
import iracemaVale from "../../assets/sponsors/iracemaVale.png"
import ivaldoPrado from "../../assets/sponsors/ivaldoPrado.png"
import qBall from "../../assets/sponsors/Q-ball.png"
import rodrigolago from "../../assets/sponsors/rodrigoLago.png"
import ulissesSousa from "../../assets/sponsors/ulissesSousa.png"





const slides = [
    {nome:"OAB/MA", img: oab},
    {nome:"CAAMA", img: caama},
    {nome:"Mendes e Lobato", img: MendesELobato},
    {nome:"Olivia Castro", img: OliviaCastro},
    {nome:"Magnolia", img: Magnolia},
    {nome:"Kaio Saraiva", img: kaioSaraiva},
    {nome:"arena Aririzal", img: arenaAririzal},
    {nome:"arena P12", img: arenaP12},
    {nome:"Gilson Ramalho", img: gilsonRamalho},
    {nome:"Iracema Vale", img: iracemaVale},
    {nome:"Ivaldo Prado", img: ivaldoPrado},
    {nome:"Q-BALL", img: qBall},
    {nome:"Rodrigo Lago", img: rodrigolago},
    {nome:"Ulisses Sousa", img: ulissesSousa},
];

function Sponsors(){
    return(
        <div style ={{width:"100%", height:"100%"}}>
            <PageContainer>
                <TitleBarContainer>
                    <TitleName>PATROCINADORES</TitleName>
                </TitleBarContainer>
                <ContentContainer>
                    {slides.map((patrocinador)=>(
                        <SponsorshipContainer key = {null}>
                            <SponsorshipCard>
                                <SponsorshipImg style={{backgroundImage: `URL(${patrocinador.img})`}}/>
                                <SponsorshipName>
                                {patrocinador.nome}
                                </SponsorshipName>
                            </SponsorshipCard>
                        </SponsorshipContainer>              
                    ))}
                </ContentContainer>
            </PageContainer>
        </div>
    )
}

export default Sponsors;